import React from 'react';
import { colors } from '@insurancemenu/imenu-components-lib';
import { NotificationImportant, NoteAdd, Delete, WarningFilled } from '@insurancemenu/imenu-components-lib/dist/icons';

/**
 * @deprecated Use ModalType from the library instead
 */
export enum ModalType {
  WARNING = 'WARNING',
  NOTIFICATION = 'NOTIFICATION',
  CREATION = 'CREATION',
  DELETE = 'DELETE',
  NO_ICON = 'NO_ICON',
  SUCCESS = 'SUCCESS',
}

/**
 * @deprecated Use iconLayout from the library instead
 */
export const iconLayout = (modalType: ModalType, iconStyle = ''): JSX.Element => {
  switch (modalType) {
    case ModalType.NOTIFICATION:
      return <NotificationImportant width="5.6rem" className={iconStyle} color={colors.orange[500]} />;
    case ModalType.SUCCESS:
      return <NotificationImportant width="5.6rem" className={iconStyle} color={colors.green[600]} />;
    case ModalType.CREATION:
      return <NoteAdd width="5.6rem" className={iconStyle} color={colors.green[600]} />;
    case ModalType.DELETE:
      return <Delete width="5.6rem" className={iconStyle} color={colors.red[600]} />;
    case ModalType.NO_ICON:
      return <></>;
    case ModalType.WARNING:
    default:
      return <WarningFilled width="5.6rem" className={iconStyle} color={colors.orange[500]} />;
  }
};
